export default __webpack_public_path__ + "static/media/671.8acbb2e8.png";